import React from 'react';
import {PageHeader} from 'src/design/organisms/PageHeader';
import {SsoProviderSection} from '../sections/SsoProviderSection';

export interface InstanceSsoTabProps {
  instanceId: number;
}

export const InstanceSsoTab: React.FC<InstanceSsoTabProps> = ({instanceId}) => {
  return (
    <>
      <PageHeader>
        <PageHeader.Title subtitle="Manage SAML single sign-on for this instance">
          Single Sign-On
        </PageHeader.Title>
      </PageHeader>

      <SsoProviderSection instanceId={instanceId} />
    </>
  );
};
